export default {
  feedbackItems: [],
  feedbackItem: undefined,
};
